import { useEffect, useState } from "react";

// Sections mount fresh on every tab switch (SectionTabs' TabPanel renders only
// the active index), but the tables fed straight from the page-level payload
// already hold their rows in memory at that moment — nothing is in flight, so
// neither `refetching` nor MUI's own loading overlay would ever fire for them.
// This gives those tables a brief loading state on mount so every table in a
// section reads the same way while its hook-driven siblings genuinely fetch.
// Deliberately short: long enough to register as a loading state, short enough
// that it never delays data that is already present.
export function useMountFlash(ms = 450) {
  const [flashing, setFlashing] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setFlashing(false), ms);
    return () => clearTimeout(timer);
  }, [ms]);

  return flashing;
}
